import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import VideoOverlay from './components/VideoOverlay.jsx'
import Config from './components/Config.jsx'

function init() {
  const params = new URLSearchParams(location.search);

  let Component = VideoOverlay; // VideoOverlay como componente padrão

  if (['config', 'dashboard'].includes(params.get('mode'))) {
    Component = Config;
  }

  const root = createRoot(document.getElementById('root'));
  root.render(
    <StrictMode>
      <Component params={params} />
    </StrictMode>
  );
}

init();